import { render, staticRenderFns } from "./SaveHeader.vue?vue&type=template&id=1208de44"
import script from "./SaveHeader.vue?vue&type=script&lang=js"
export * from "./SaveHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports